import { MouseEventHandler, ReactNode } from 'react';
import { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import { Box } from '@bridebook/ui';
import { Reviews } from '@bridebook/web/app-shared/lib/supplier/types';
import { IBreadcrumbItem } from '@bridebook/web/app-shared/lib/types';
import SupplierHeadLocation from '@bridebook/web/app-basic/components/supplier/sections/supplier-info/supplier-head-location/supplier-head-location';
import TestimonalInfo from '@bridebook/web/app-basic/components/supplier/sections/supplier-info/supplier-head-reviews-testimonials-info/supplier-head-reviews-testimonials-info';
import componentStyles from '@bridebook/web/app-basic/components/supplier/sections/supplier-info/supplier-info.style';

interface IProps {
  feedbackCount: number;
  isSupplierLoaded: boolean;
  onLocationClick: MouseEventHandler<ReactNode>;
  onTestimonialsClick?: () => void;
  reviews: Reviews;
  supplier: ISupplier;
  locationPinInfo?: IBreadcrumbItem[];
  isVenueProfileV2?: boolean;
}

const SupplierInfo = ({
  feedbackCount,
  isSupplierLoaded,
  onLocationClick,
  onTestimonialsClick,
  reviews,
  supplier,
  locationPinInfo,
  isVenueProfileV2,
}: IProps) => {
  const styles = componentStyles(isVenueProfileV2);

  return (
    <Box data-name="supplier-info">
      <Box style={styles.wrapper}>
        <Box style={styles.locationWrap}>
          <SupplierHeadLocation
            supplier={supplier}
            onLocationClick={onLocationClick}
            locationPinInfo={locationPinInfo}
          />
        </Box>
        <Box as="h1" style={styles.heading} dataTest="supplier-info-name">
          {supplier.name}
        </Box>
        <TestimonalInfo
          feedbackCount={feedbackCount}
          isSupplierLoaded={isSupplierLoaded}
          onTestimonialsClick={onTestimonialsClick}
          reviews={reviews}
        />
      </Box>
    </Box>
  );
};

export default SupplierInfo;
